import { Box, LinearProgress } from '@mui/material';

interface Props {
  progress: number; // A number between 1 and 100
  status: string; // A status message
  variant?: 'determinate' | 'indeterminate'; // Optional variant prop
}

const VNProgressModal = ({ progress, variant, status }: Props) => {
  return (
    <div className="vn-progress-modal">
      <div className="vn-progress-bar-container">
        <Box sx={{ width: '100%' }}>
          <LinearProgress variant={variant} value={progress} />
        </Box>
        <div className="vn-progress-status">{status}</div>
      </div>
    </div>
  );
};

export default VNProgressModal;
